import * as React from "react";
import {
  ClearButtons,
  FormatButtons,
  LevelSelect,
  LinkButtons,
  ListButtons,
  QuoteButtons,
  RichTextInputToolbar,
} from "ra-input-rich-text";

const RichToolbar = () => (
  <RichTextInputToolbar>
    <LevelSelect />
    <FormatButtons />
    <ListButtons />
    <LinkButtons />
    <QuoteButtons />
    <ClearButtons />
  </RichTextInputToolbar>
);

export default RichToolbar;
